"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleToolbar = exports.prepareDoubleToolbar = void 0;
const react_1 = __importDefault(require("react"));
const StackView_1 = require("../../StackView");
const Toolbar_1 = require("../../Toolbar");
const prepareDoubleToolbar = (items) => {
    return items.reduce((acc, curr) => {
        if (curr.isAction) {
            acc.actions.push(curr);
            return acc;
        }
        acc.filters.push(curr);
        return acc;
    }, { filters: [], actions: [] });
};
exports.prepareDoubleToolbar = prepareDoubleToolbar;
const doubleToolbar = ({ viewFilters = Toolbar_1.TOOLBAR_VIEW_TYPE.spotted, viewActions } = {}) => ({ disabled, items, groups, payload, buildIn }) => {
    const preparedItems = (0, exports.prepareDoubleToolbar)(items);
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.none, align: StackView_1.STACK_ALIGN.fill },
        !!preparedItems.filters.length && (react_1.default.createElement(Toolbar_1.Toolbar, { view: viewFilters, items: preparedItems.filters, buildIn: buildIn, groups: groups, payload: payload, disabled: disabled })),
        !!preparedItems.actions.length && (react_1.default.createElement(Toolbar_1.Toolbar, { view: viewActions, buildIn: buildIn, items: preparedItems.actions, groups: groups, payload: payload, disabled: disabled }))));
};
exports.doubleToolbar = doubleToolbar;
//# sourceMappingURL=doubleToolbar.js.map